// Consent record management (CIPA-defensive strict opt-in posture).
// This site currently loads zero non-essential third-party scripts; the
// record still gates any future analytics/marketing additions — check
// hasConsent('analytics') before loading anything non-essential.

const KEY = 'pn_consent';
const MAX_AGE_DAYS = 365;

export function gpcEnabled() {
  return typeof navigator !== 'undefined' && navigator.globalPrivacyControl === true;
}

export function readConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || !parsed.ts) return null;
    const ageDays = (Date.now() - new Date(parsed.ts).getTime()) / 86400000;
    if (Number.isNaN(ageDays) || ageDays > MAX_AGE_DAYS) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveConsent({ analytics, marketing }) {
  const record = {
    necessary: true,
    analytics: gpcEnabled() ? false : Boolean(analytics),
    marketing: gpcEnabled() ? false : Boolean(marketing),
    gpc: gpcEnabled() || undefined,
    ts: new Date().toISOString()
  };
  try {
    localStorage.setItem(KEY, JSON.stringify(record));
  } catch {
    /* private mode — banner will just reappear next visit */
  }
  return record;
}

export function hasConsent(category) {
  if (category === 'necessary') return true;
  const record = readConsent();
  return Boolean(record && record[category]);
}

const OPEN_SETTINGS_EVENT = 'pn:cookie-settings';

export function openCookieSettings() {
  window.dispatchEvent(new CustomEvent(OPEN_SETTINGS_EVENT));
}

export function onOpenCookieSettings(handler) {
  window.addEventListener(OPEN_SETTINGS_EVENT, handler);
  return () => window.removeEventListener(OPEN_SETTINGS_EVENT, handler);
}
